<template>
  <div>
    <el-dialog
      title="设置签名"
      :visible.sync="signQrcodeDialogVisible"
      width="300px"
    >
      <div
        style="
          color: red;
          font-weight: bold;
          font-size: 16px;
          text-align: center;
        "
      >
        检测到未设置签名
      </div>
      <div
        style="
          color: red;
          font-weight: bold;
          font-size: 16px;
          text-align: center;
        "
      >
        请用手机扫描二维码设置签名
      </div>
      <div style="width: 100%; text-align: center">
        <vue-qr :size="200" :text="signQrcode"></vue-qr>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="signQrcodeDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import TokenCache from '@/utils/cache/TokenCache'
import vueQr from 'vue-qr'
export default {
  data() {
    return {
      signQrcode: '',
      signQrcodeDialogVisible: false,
    }
  },
  props: {},
  components: { vueQr },
  methods: {
    openDialog() {
      this.signQrcodeDialogVisible = true
    },
  },
  mounted() {},
  created() {
    this.signQrcode =
      window.location.origin + '/UserSign?token=' + TokenCache.getToken()
  },
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped></style>
